import React, { Component } from "react";
import Styler from "./Styler";
import "./Content.css";

class Content extends Component {
  render() {
    return (
      <div className="ContentDiv MidPanel">
        <div className="TopSplit" />
        <Styler />
        <div className="BottomSplit" />
      </div>
    );
  }
}

export default Content;
